import { Stack, Typography, Tooltip } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'

import { preview } from '@/components/form/preview'

import { CalculatedServiceTime, DetectedTimeProps } from '../../typings'
import { getCalculatedServiceTime } from '../../utils'

import { formatMinutes } from './intl'
import * as OrderTexts from '../../../../../../../intl'

export function DetectedServiceTime(props: DetectedTimeProps) {
  const { trackingData, rescheduleBehavior } = props

  const { time, locID, text }: CalculatedServiceTime = getCalculatedServiceTime(
    trackingData,
    rescheduleBehavior,
  )
  const detectedTimeText: string =
    time > 0
      ? formatMinutes(Math.floor(Math.abs(time) / 60))
      : OrderTexts.getUnableToCalculateText()

  const detectedTimeDescription: string | undefined = locID ? text : undefined

  return (
    <preview.Field
      label={
        <Stack direction="row" spacing={1}>
          <Typography variant="caption">{OrderTexts.getCalculatedServiceTimeText()}</Typography>
          {detectedTimeDescription && (
            <Tooltip title={detectedTimeDescription}>
              <span>
                <InfoOutlined fontSize="small" />
              </span>
            </Tooltip>
          )}
        </Stack>
      }
    >
      {detectedTimeText}
    </preview.Field>
  )
}
